module.exports = __webpack_public_path__ + "static/img/2.2c1692f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/2.png
// module id = mK9W
// module chunks = 0